$('.copy-text').click(function() {
  var dataClasTarget = $(this).data('class-target')
  if (dataClasTarget) {
    if (navigator.clipboard) {
      var text = $(`.${dataClasTarget}`).data('copy-text')
      navigator.clipboard.writeText(text).then(function () {
        alert('Text copied!')
      }, function () {
          alert('Failure to copy. Check permissions for clipboard')
      });
    } else {
      var text = $(`.${dataClasTarget}`)
      text.removeClass('d-none')
      text.select()
      document.execCommand('copy')
      text.addClass('d-none')
      alert('Text copied!')
    }
  } else {
    alert('Data class target not found!')
  }
})
